import { useHistory } from 'react-router-dom';
import { ANXIETY } from 'components/shared/types';
import MailingList from 'components/assessment-email';
import { ANXIETY_ASSESSMENT_RESULT } from 'constants/localStorageKey';

const AnxietyEmail = (): JSX.Element => {
  const history = useHistory();
  const data = localStorage.getItem(ANXIETY_ASSESSMENT_RESULT);

  const handleNextPage = () => {
    history.push('/anxiety-assessment-result');
  };

  if (!data) {
    history.push('/anxiety-self-test');
    return <></>;
  }

  return <MailingList handleNextPage={handleNextPage} condition={ANXIETY} />;
};

export default AnxietyEmail;
